export default __webpack_public_path__ + "static/media/scoreImage.63d3cd9b.png";